import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'cookie_notice_ack';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <p>
          We use cookies to ensure the best experience and improve our services.
          {' '}
          <Link to="/cookies">Learn more</Link>
        </p>
        <button className="btn btn-primary cookie-banner-btn" onClick={accept}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
